import {
  GET_DADOS_CNPJ_INIT,
  GET_DADOS_CNPJ_SUCCESS,
  DADOS_EXTERNOS_CLEAN_UP,
  ERROR_DADOS_EXTERNOS_MSG
} from '../actionTypes';


export const getDadosCnpjInit = (data) => ({
  type: GET_DADOS_CNPJ_INIT,
  payload: data
});

export const getDadosCnpjSuccess = (data) => {
  return {
    type: GET_DADOS_CNPJ_SUCCESS,
    payload: data
  };
};

export const dadosExternosCleanUp = (data) => ({
  type: DADOS_EXTERNOS_CLEAN_UP,
  payload: data
});

export const dadosExternosErrorMsg = (data) => ({
  type: ERROR_DADOS_EXTERNOS_MSG,
  payload: data
});

